import { Controller, UseFormReturn } from 'react-hook-form';

import { Label } from 'components/Label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/Select';
import { Flex, Grid } from 'components/layout';
import { Typography } from 'components/typography';
import {
  LTLItem,
  LTL_UNIT_SYSTEMS,
  QuickQuoteInputs,
} from 'pages/QuoteView/Quoting/RequestQuickQuote/types';
import { TMS } from 'types/enums/Integrations';

import { LTLLinearFeetInput } from '../LTLLinearFeetInput';
import { LTLShipmentStackingAndSideLoadControls } from '../components/LTLShipmentStackingAndSideLoadControls';

interface CommoditySectionProps {
  formMethods: UseFormReturn<QuickQuoteInputs, any, QuickQuoteInputs>;
  integrationName?: TMS;
  replaceItems?: (items: LTLItem[]) => void;
}

// Commodity section for LTL Quick Quote.
export function CommoditySection({
  formMethods,
  integrationName,
  replaceItems,
}: CommoditySectionProps) {
  const { control } = formMethods;

  return (
    <Flex direction='col' gap='lg' className='w-full mx-0'>
      <Typography
        variant='h5'
        className='text-neutral-800 font-semibold whitespace-nowrap'
      >
        Total Shipment
      </Typography>

      <Grid cols='1' gap='lg' align='end' className='w-full mx-0'>
        <div>
          <Label name='ltl.commodity.units' required>
            Units
          </Label>
          <Controller
            name='ltl.commodity.units'
            control={control}
            defaultValue={LTL_UNIT_SYSTEMS.IMPERIAL}
            rules={{ required: 'Units is required' }}
            render={({ field }) => (
              <Select onValueChange={field.onChange} value={field.value ?? ''}>
                <SelectTrigger className='w-full mt-1'>
                  <SelectValue placeholder='Select units' />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value={LTL_UNIT_SYSTEMS.IMPERIAL}>
                    in/lbs
                  </SelectItem>
                  <SelectItem value={LTL_UNIT_SYSTEMS.METRIC}>cm/kg</SelectItem>
                </SelectContent>
              </Select>
            )}
          />
        </div>

        <LTLShipmentStackingAndSideLoadControls
          formMethods={formMethods}
          showStackable={true}
        />
      </Grid>

      <LTLLinearFeetInput
        formMethods={formMethods}
        integrationName={integrationName ?? TMS.Tai}
        replaceItems={replaceItems}
      />
    </Flex>
  );
}
